import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../shared/services';
import { FORM_TEXTS } from './../../objects/placeholders';


@Component({
  selector: 'app-sample-images',
  templateUrl: './sample-images.component.html',
  styleUrls: ['./sample-images.component.scss']
})
export class SampleImagesComponent implements OnInit {

  public info;

  constructor(
    public dialogRef: MatDialogRef<SampleImagesComponent>,
    public storageService: StorageService
  ) { }

  ngOnInit() {
    this.setLanguage();
  }

  closePopup() {
    this.dialogRef.close();
  }

  setLanguage(data?) {
    const lang = this.storageService.get('language');
    this.info = lang ? FORM_TEXTS[lang].sample_images : FORM_TEXTS['English'].sample_images;
  }

}
